import { Button, Flex, Heading, Input, Text } from "@chakra-ui/react";

import { useCallback, useState } from "react";
import { LuSearch } from "react-icons/lu";
import TravelPageLayout from "@features/services/travel/TravelPageLayout";

const TravelLandingView = ({
  onGetStarted,
  onTrackApplication,
}: {
  onGetStarted: () => void;
  onTrackApplication: (ref: string) => void;
}) => {
  const [trackingRef, setTrackingRef] = useState("");

  const onSearch = useCallback(() => {
    const trimmed = trackingRef.trim();
    if (trimmed !== "") {
      onTrackApplication(trimmed);
    }
  }, [trackingRef, onTrackApplication]);

  const onKeyDown = useCallback(
    (e: React.KeyboardEvent) => {
      if (e.key === "Enter") {
        onSearch();
      }
    },
    [onSearch],
  );

  return (
    <TravelPageLayout gap={8} align="center">
      <Flex flexDirection="column" gap={2} w="full" maxW="sm">
        <Text fontSize="xs" textAlign="center">
          Already applied? Enter your tracking number to check your application
          status.
        </Text>
        <Flex gap={2}>
          <Input
            placeholder="e.g. CWG1234567890"
            value={trackingRef}
            onChange={(e) => setTrackingRef(e.target.value)}
            onKeyDown={onKeyDown}
            size="md"
            borderColor="border.light"
          />
          <Button
            size="md"
            onClick={onSearch}
            disabled={trackingRef.trim() === ""}
            flexShrink={0}
          >
            <LuSearch />
            Search
          </Button>
        </Flex>
      </Flex>

      <Flex flexDirection="column" gap={2} textAlign="center">
        <Heading size="xl" color="fg">
          Travel to China with Gyasi
        </Heading>
        <Text fontSize="sm" maxW="md" mx="auto">
          Choose from our curated packages or build your own. We handle visas,
          flights, hotels, and on-ground support so you can focus on what
          matters.
        </Text>
      </Flex>

      <Button size="xs" onClick={onGetStarted}>
        Get started
      </Button>
    </TravelPageLayout>
  );
};

export default TravelLandingView;
